import { GzDialogWebComponent } from 'apps/webcomponents/src/ui/gzDialog';
import { GzDialog } from 'apps/webcomponents/src/ui/gzDialog/component/GzDialog';
import { QuarantineSaveFormWebComponent } from '../quarantineSaveForm';

let bodyContent: QuarantineSaveFormWebComponent;
export class SaveDialog {
  static open(translateFn: Function, containerRef: HTMLElement): GzDialogWebComponent {
    const bodyContent = this.getBodyContent(translateFn);
    const dialogConfigs: GzDialog = {
      headline: translateFn('Save#preserve state'),
      bodyContent,
      isOpen: true,
      isWindow: true,
    };

    const dialog = GzDialogWebComponent.buildDialogElement(dialogConfigs, containerRef);

    return dialog;
  }

  static getBodyContent(translateFn): HTMLElement {
    const quarantineSaveForm = new QuarantineSaveFormWebComponent();
    quarantineSaveForm.translateFn = translateFn;
    bodyContent = quarantineSaveForm;

    return quarantineSaveForm;
  }
}
